var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/ok",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2954,9.6055 L11.7274,15.6055 C11.5394,15.8525 11.2484,15.9985 10.9384,16.0005 L10.9314,16.0005 C10.6244,16.0005 10.3344,15.8585 10.1444,15.6165 L7.7124,12.5095 C7.3724,12.0755 7.4484,11.4465 7.8834,11.1065 C8.3184,10.7655 8.9464,10.8415 9.2874,11.2775 L10.9204,13.3635 L14.7044,8.3945 C15.0384,7.9555 15.6664,7.8695 16.1064,8.2045 C16.5454,8.5395 16.6304,9.1665 16.2954,9.6055 M18.0004,3.0005 L6.0004,3.0005 C4.3454,3.0005 3.0004,4.3455 3.0004,6.0005 L3.0004,18.0005 C3.0004,19.6545 4.3454,21.0005 6.0004,21.0005 L18.0004,21.0005 C19.6544,21.0005 21.0004,19.6545 21.0004,18.0005 L21.0004,6.0005 C21.0004,4.3455 19.6544,3.0005 18.0004,3.0005",
    id: "path-1",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.e1c94f92.svg";
export { ForwardRef as ReactComponent };